import { FieldKinds } from '@site-mate/dashpivot-shared-library';

import { FormFieldHeader } from '../../common/register/form-field-header/form-field-header';

export class PrefilledTableHeader extends FormFieldHeader {
  constructor(item) {
    super(item);

    this.columns = [];

    item.columns.forEach((column) => {
      const headerItem = {
        ...column,
        description: column.heading,
        templateId: this.templateId,
        fieldId: this.id,
        headerKind: FieldKinds.Table,
      };
      this.columns.push(...new FormFieldHeader(headerItem).columns);
    });
  }
}
